import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'app-products-renderer',
  templateUrl: './products-renderer.component.html',
  styleUrls: ['./products-renderer.component.scss'],
  standalone: false,
})
export class ProductsRendererComponent {
  products?: string;
  agInit(params: ICellRendererParams): void {
    if (params.value) {
      this.products = this.formatProducts(params.value);
    }
  }
  private formatProducts(products: string): string {
    return products
      .split(',')
      .map((p) => p.trim())
      .filter((p) => !!p)
      .sort((a, b) => a.localeCompare(b))
      .filter((item, index, arr) => arr.indexOf(item) === index)
      .join(', ');
  }
}
